import { useReferencedFn } from './useReferencedFn.js';
import { useState, useEffect } from 'react';

function useAsyncValue(asyncFunction) {
  const [value, setValue] = useState(void 0);
  const functionRef = useReferencedFn(asyncFunction);
  useEffect(() => {
    let isMounted = true;
    void functionRef.current().then((result) => {
      if (isMounted) {
        setValue(result);
      }
    });
    return () => {
      isMounted = false;
    };
  }, [
    functionRef
  ]);
  return value;
}

export { useAsyncValue };
//# sourceMappingURL=useAsyncValue.js.map
